import { HEADLINE_BASE_CLASSNAME } from '@vfde-brix/ws10/headline';
import { Accordion } from '@vfde-brix/ws10/accordion';
import { getFiberObjectProperty } from '../util/cms';
import { AppHtmlId } from '../enums/elementId';
import { trackFootnoteLink } from '../util/tracking';
import { HtmlSelector } from '../constants';
import { closeAccordionItems } from './accordion';
import { JarvisProduct } from '@vfde-sails/avc-core';

const FOOTNOTE_LINK_STYLE_CLASSNAME = 'ws10-footnote-link-style';

const addOnClickEvent = (linkEl: HTMLElement, footnoteNumber: number) => {
    const footnoteItemIndex = footnoteNumber - 1;
    const footnoteAccordion: Accordion = getFiberObjectProperty(AppHtmlId.DYNAMIC_FOOTNOTE);
    const { items } = footnoteAccordion?.getProperties() || {};
    const currentItem = items?.[footnoteItemIndex];
    const footnoteEl = footnoteAccordion.getContainerElement() as HTMLElement;

    if (!currentItem || !footnoteEl) {
        return;
    }

    linkEl.onclick = () => {
        // close all items first as jumping is broken if the accordion is already opened
        closeAccordionItems(footnoteAccordion);

        footnoteAccordion.toggleItemById(currentItem.stdId, true);
        trackFootnoteLink(linkEl.innerText.slice(0, -1));
    };
};

const mountFootnoteLink = (element: HTMLElement, footnoteNumber: number) => {
    if (element.getElementsByClassName(FOOTNOTE_LINK_STYLE_CLASSNAME).length) {
        return;
    }

    element.innerHTML = `${element.innerHTML}` +
        `<sup class="${FOOTNOTE_LINK_STYLE_CLASSNAME}">${footnoteNumber}</sup>`;

    addOnClickEvent(element, footnoteNumber);
};

const removeFootnoteLink = (element: HTMLElement) => {
    const footnote = element.querySelector(HtmlSelector.FOOTNOTE);
    footnote && footnote.remove();
};

export const mountFootnoteLinks = (tariffs?: JarvisProduct[], fiberAvailable?: boolean) => {
    // Footnote link 1: Selected tariff
    const offerSummaryCard = document.getElementById(AppHtmlId.OFFER_SUMMARY_CARD);

    const [ headlineEl ] = offerSummaryCard?.getElementsByClassName(HEADLINE_BASE_CLASSNAME) || [];

    if (!(headlineEl instanceof HTMLElement)) {
        return;
    }

    // don't mount footnote link 2 when no tariffs are available
    if (!tariffs?.length) {
        removeFootnoteLink(headlineEl);
        return;
    }
    // same if there is an avc result and fiber is not available
    if (false === fiberAvailable) {
        removeFootnoteLink(headlineEl);
        return;
    }

    mountFootnoteLink(headlineEl, 1);
};
